import { render, staticRenderFns } from "./UpcomingPayroll.vue?vue&type=template&id=6831fd00&scoped=true"
import script from "./UpcomingPayroll.vue?vue&type=script&lang=ts"
export * from "./UpcomingPayroll.vue?vue&type=script&lang=ts"
import style0 from "./UpcomingPayroll.vue?vue&type=style&index=0&id=6831fd00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6831fd00",
  null
  
)

export default component.exports